import { render, staticRenderFns } from "./MapNewLayout.vue?vue&type=template&id=36eb887c&"
import script from "./MapNewLayout.vue?vue&type=script&lang=ts&"
export * from "./MapNewLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports